import { render, staticRenderFns } from "./VirtualSubsTable.vue?vue&type=template&id=1d627144&scoped=true"
import script from "./VirtualSubsTable.vue?vue&type=script&lang=js"
export * from "./VirtualSubsTable.vue?vue&type=script&lang=js"
import style0 from "./VirtualSubsTable.vue?vue&type=style&index=0&id=1d627144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d627144",
  null
  
)

export default component.exports